module.exports = __webpack_public_path__ + "static/consumedHero-022233d7ea1f89bf56cccad077c3e4d2.jpg";